<template>
  <v-sheet
    class="d-flex flex-column pa-3 mb-2 mb-md-0 sheet"
    :style="{ width: width ? width : '240px' }"
  >
    <div class="mb-2 title">{{ title }}</div>
    <ul
      v-if="items && Object.keys(items).length > 0"
      style="overflow-y: auto"
    >
      <li
        v-for="(item, i) in items"
        :key="'type-' + i"
        class="d-flex flex-wrap justify-space-between mb-1"
      >
        <div class="pr-5 text">{{ item.label }}</div>
        <div
          class="text-value"
          :style="{ color: $vuetify.theme.global?.current?.colors.primary }"
        >
          {{ item.value?.toLocaleString() || 0 }}
        </div>
      </li>
    </ul>
    <div v-else>{{ t('dashboard.details.no-data') }}</div>
  </v-sheet>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  width: String,
  title: String,
  items: Object as PropType<Record<string, any>>,
})
</script>

<style scoped>
.sheet {
  background: #e6f8f8;
  border-radius: 10px;
  min-width: 230px;
  border-radius: 10px;
}

.title,
.text {
  font-size: 14px;
  font-style: normal;
  line-height: 18px;
}

.title {
  font-weight: 700;
}
.text {
  font-weight: 400;
  max-width: 195px;
}
.text-value {
  font-size: 18px;
}
</style>
